<template>
  <div class="funnel-item" :class="{ selected: selected }" :style="style">
    <template v-if="funnel.level != 0">
      <div class="d-flex align-items-start justify-content-between gap-3">
        <div class="d-flex flex-column">
          <h4 class="text-semibold">{{ funnel.name }}</h4>
          <h5 v-if="funnel.is_end" class="text-dark-40">
            Página de obrigado
          </h5>
          <template v-else>
            <h5 class="text-dark-40">
              {{ funnel.product.name }}
            </h5>
            <bp-tag
              class="mt-2"
              :text="stepType.text"
              :color="stepType.color"
            />
          </template>
        </div>

        <div class="d-flex align-items-center justify-content-center gap-3">
          <snow-button
            size="sm"
            text="Editar"
            variant="gray"
            @click="editBlock"
          />
          <snow-button
            size="sm"
            text="Excluir"
            variant="danger"
            @click="deleteStep"
          />
        </div>
      </div>
    </template>

    <div v-else-if="!funnel.is_end" class="d-flex align-items-start gap-3 mb-6">
      <div class="d-flex flex-column justify-content-between">
        <h4 class="text-semibold">{{ funnel.name }}</h4>
        <h5 class="text-dark-40">
          {{ funnel.product.name }}
        </h5>
      </div>
    </div>

    <snow-button
      v-if="funnel.level === 0"
      variant="positive"
      block
      text="Próxima etapa"
      class="mt-5"
      @click="() => addAction('first-step')"
      :style="{
        'pointer-events': tree.length > 1 ? 'none' : 'auto',
        opacity: tree.length > 1 ? 0.6 : 1
      }"
    />
    <template v-else>
      <snow-button
        v-if="funnel.cta_text"
        block
        class="mt-5"
        :text="funnel.cta_text"
        @click="() => addAction('yes')"
        variant="positive"
        :style="{
          'pointer-events': funnel.action_yes ? 'none' : 'auto',
          opacity: funnel.action_yes ? 0.6 : 1
        }"
      />
      <snow-button
        v-if="funnel.ctb_text"
        block
        class="mt-4"
        :text="funnel.ctb_text"
        @click="() => addAction('no')"
        variant="danger"
        :style="{
          'pointer-events': funnel.action_no ? 'none' : 'auto',
          opacity: funnel.action_no ? 0.6 : 1
        }"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    selected: Boolean,
    options: {
      type: Object
    },
    funnel: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      width: this.options.width,
      hasDragged: false
    };
  },
  created() {
    this.mouseX = 0;
    this.mouseY = 0;

    this.lastMouseX = 0;
    this.lastMouseY = 0;

    this.dragging = false;
  },
  mounted() {
    document.documentElement.addEventListener(
      "mousemove",
      this.handleMove,
      true
    );
    document.documentElement.addEventListener(
      "mousedown",
      this.handleDown,
      true
    );
    document.documentElement.addEventListener("mouseup", this.handleUp, true);
  },
  beforeDestroy() {
    document.documentElement.removeEventListener(
      "mousemove",
      this.handleMove,
      true
    );
    document.documentElement.removeEventListener(
      "mousedown",
      this.handleDown,
      true
    );
    document.documentElement.removeEventListener(
      "mouseup",
      this.handleUp,
      true
    );
  },
  methods: {
    handleMove(e) {
      this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
      this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;

      if (this.dragging) {
        let diffX = this.mouseX - this.lastMouseX;
        let diffY = this.mouseY - this.lastMouseY;

        this.lastMouseX = this.mouseX;
        this.lastMouseY = this.mouseY;

        this.moveWithDiff(diffX, diffY);

        this.hasDragged = true;
      }
    },
    handleDown(e) {
      this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
      this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;

      this.lastMouseX = this.mouseX;
      this.lastMouseY = this.mouseY;

      const target = e.target || e.srcElement;
      if (this.$el.contains(target) && e.which === 1) {
        this.dragging = true;

        this.$emit("select");

        if (e.preventDefault) e.preventDefault();
      }
    },
    handleUp() {
      if (this.dragging) {
        this.dragging = false;

        if (this.hasDragged) {
          this.save();
          this.hasDragged = false;
        }
      }
    },
    save() {
      this.$emit("update");
    },
    deleteStep() {
      this.$emit("delete");
    },
    editBlock() {
      this.$emit("edit", this.funnel);
    },
    addAction(type) {
      this.$emit("add", type, { parent: this.funnel.id });
    },
    moveWithDiff(diffX, diffY) {
      let left = this.funnel.position_x + diffX / this.options.scale;
      let top = this.funnel.position_y + diffY / this.options.scale;

      //performance
      let index = this.tree.findIndex(step => step.id === this.funnel.id);
      let tree = [...this.tree];
      tree[index] = { ...tree[index], position_x: left, position_y: top };

      this.$store.commit("funnel/setTree", tree);
    }
  },
  computed: {
    ...mapState("funnel", ["tree"]),
    stepType() {
      if (this.funnel.is_end)
        return { text: "Página de obrigado", color: "primary" };
      if (this.tree.find(step => step.action_no?.id === this.funnel.id))
        return { text: "Downsell", color: "negative" };
      if (
        this.tree.find(step => step.action_yes?.id === this.funnel.id) ||
        this.funnel.level === 1
      )
        return { text: "Upsell", color: "green" };
      return undefined;
    },
    productOffer() {
      return this.funnel?.offer?.name;
    },
    productPlan() {
      return this.funnel?.plan?.name;
    },
    treeIsStarted() {
      return this.tree.find(step => step.level === 1);
    },
    style() {
      return {
        top:
          this.options.center.y +
          this.funnel.position_y * this.options.scale +
          "px",
        left:
          this.options.center.x +
          this.funnel.position_x * this.options.scale +
          "px",
        width: this.width + "px",
        transform: "scale(" + (this.options.scale + "") + ") translateY(-100%)",
        transformOrigin: "top left"
      };
    },
    isDownSell() {
      return this.tree.find(step => step.action_no?.id === this.funnel.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.funnel-item {
  position: absolute;
  padding: 24px;
  border-radius: 16px;
  box-sizing: border-box;
  background: var(--bg-1);
  border: 1px solid var(--dark-10);

  /* 4 */
  cursor: move;
  z-index: 1;

  &.selected {
    z-index: 2;
  }

  .type-badge {
    font-weight: 500;
    padding: 4px 10px;
    border-radius: 4px;
    white-space: nowrap;

    &.upsell {
      background: #008f2b33;
      color: var(--l-success-45);
    }
    &.downsell {
      background: #ffd4d7d9;
      color: var(--l-error-45);
    }
  }
}
</style>
